// DivisionOrgSalesAdmin.js
import api from '@/api'
import sharedDivisionOrgSalesWebModule, { setApiGetter } from '@shared-library/store/modules/divisionOrgSalesWeb.js'

// 设置 API getter
setApiGetter(() => api);

// 扩展共享的store模块
const sharedModule = sharedDivisionOrgSalesWebModule;

// 扩展state
const extendedState = {
  ...sharedModule.state,
  // 添加项目特定的状态
  // adminSpecificState: null
}

// 扩展getters
const extendedGetters = {
  ...sharedModule.getters,
  // 添加项目特定的getters
  // adminSpecificGetter: state => state.adminSpecificState
}

// 扩展actions
const extendedActions = {
  ...sharedModule.actions,
  // 添加项目特定的actions
  // async adminSpecificAction({ commit }, payload) {
  //   // 实现特定逻辑
  // }
}

// 扩展mutations
const extendedMutations = {
  ...sharedModule.mutations,
  // 添加项目特定的mutations
  // setAdminSpecificState(state, payload) {
  //   state.adminSpecificState = payload;
  // }
}

export default {
  namespaced: true,
  state: extendedState,
  getters: extendedGetters,
  actions: extendedActions,
  mutations: extendedMutations
}